import VerticalTimelineContainer from './VerticalTimelineContainer';

export default VerticalTimelineContainer;
